import { mode } from '@chakra-ui/theme-tools';

const baseStyle = {
  container: {
    border: 'none',
  },
  button: {
    fontWeight: 'bold',
  },
};

const Accordion = {
  baseStyle,
  variants: {
    wpp: props => ({
      container: {
        border: 'none',
        borderRadius: 'lg',
        boxShadow: mode('base', 'lg')(props),
        overflow: 'hidden',
      },
      button: {
        px: 4,
        py: 2,
        minHeight: '36px',
        bgGradient: mode(
          'linear(to-r, WPPNavy.300, WPPNavy.200)',
          'linear(to-r, WPPNavy.400, WPPNavy.300)',
        )(props),
        color: 'white',
        fontWeight: 'bold',
        fontSize: 'md',
        letterSpacing: 'wide',
        borderRadius: 'lg',
        boxShadow: 'lg',
        _hover: {
          bgGradient: mode(
            'linear(to-r, WPPNavy.400, WPPNavy.200)',
            'linear(to-r, WPPNavy.400, WPPNavy.300)',
          )(props),
        },
        _expanded: {
          boxShadow: 'xl',
        },
        transition: 'all 0.2s',
      },
      panel: {
        bg: mode('gray.50', '#181A2B')(props),
        borderBottomRadius: 'lg',
        borderColor: mode('WPPNavy.200', 'WPPNavy.400')(props),
        boxShadow: 'md',
        px: 6,
        py: 6,
        color: mode('graphite.500', 'white.100')(props),
      },
      icon: {
        color: 'white',
        _expanded: {
          color: mode('WPPGreen.400', 'WPPGreen.300')(props),
        },
      },
    }),
    bordered: props => ({
      container: {
        border: '1px solid',
        borderRadius: 'sm',
        borderColor: 'gray.100',
        overflow: 'hidden',
        mb: 4,
      },
      button: {
        px: 4,
        py: 2,
        minHeight: '36px',
        bg: mode('gray.100', '#181A2B')(props),
        fontWeight: 'bold',
        fontSize: 'md',
        _hover: {
          bg: mode('gray.300', '#282C3D')(props),
        },
        transition: 'all 0.2s',
      },
      panel: {
        boxShadow: 'none',
      },
      icon: {
        _expanded: {},
      },
    }),
    gray: props => ({
      container: {
        border: 'none',
        borderRadius: 'lg',
        boxShadow: mode('base', 'lg')(props),
        overflow: 'hidden',
      },
      button: {
        px: 4,
        py: 2,
        minHeight: '36px',
        bgColor: mode('gray.100', 'gray.700')(props),
        color: mode('graphite.500', 'white.100')(props),
        fontWeight: 'bold',
        fontSize: 'md',
        letterSpacing: 'wide',
        borderRadius: 'lg',
        boxShadow: 'lg',
        _hover: {
          bgColor: mode('gray.300', 'gray.600')(props),
        },
        _expanded: {
          boxShadow: 'xl',
        },
        transition: 'all 0.2s',
      },
      panel: {
        bg: mode('gray.50', '#181A2B')(props),
        borderBottomRadius: 'lg',
        borderColor: mode('WPPNavy.200', 'WPPNavy.400')(props),
        boxShadow: 'md',
        px: 6,
        py: 6,
        color: mode('graphite.500', 'white.100')(props),
      },
      icon: {
        color: mode('graphite.500', 'white.100')(props),
        _expanded: {
          color: mode('WPPGreen.400', 'WPPGreen.300')(props),
        },
      },
    }),
  },
};

export default Accordion;
